// Mode continu du déclencheur : un appui long fait partir des photos en rafale tant que le doigt reste posé. Le premier appui prend une
// photo comme d'habitude ; si le déclencheur est encore enfoncé après `delayMs`, une photo part toutes les `intervalMs`. Pur : les
// minuteries sont celles du navigateur (setTimeout / setInterval), remplaçables par des fausses dans les tests.
import { BURST_DELAY_MS, BURST_INTERVAL_MS } from '../config/constants.js';

/**
 * Que faire à chaque tick de la rafale ?
 *  - 'stop'     : plus rien à faire (déclencheur relâché, pause, niveau déjà fini)
 *  - 'finish'   : la pellicule est vide (la dernière vue est partie au premier appui) : il faut conclure le niveau tout de suite (écran
 *                 « Batterie vide »), sans attendre que le doigt se lève ; la rafale s'arrête
 *  - 'shoot'    : une photo de plus
 * @param {{ isShooting: boolean, isPaused: boolean, state: string, filmLeft: number }} game
 * @returns {'stop'|'finish'|'shoot'}
 */
export function burstAction({ isShooting, isPaused, state, filmLeft }) {
  if (!isShooting || isPaused || state !== 'playing') return 'stop';
  return filmLeft <= 0 ? 'finish' : 'shoot';
}

/**
 * @param {object} options
 * @param {() => boolean|void} options.shoot  prend une photo ; renvoie false quand la rafale doit s'arrêter (pellicule vide, niveau fini, pause…)
 * @param {() => void} [options.onStart]  la rafale commence (le décor se libère : on peut viser entre deux photos)
 * @param {() => void} [options.onStop]  la rafale se termine (relâché, plus de pellicule…)
 * @param {number} [options.delayMs]  durée d'appui avant la première photo de la rafale
 * @param {number} [options.intervalMs]  délai entre deux photos de la rafale
 */
export function createBurst({ shoot, onStart, onStop, delayMs = BURST_DELAY_MS, intervalMs = BURST_INTERVAL_MS }) {
  let delayTimer = null;
  let intervalTimer = null;
  let active = false;

  function stop() {
    clearTimeout(delayTimer);
    clearInterval(intervalTimer);
    delayTimer = null;
    intervalTimer = null;
    if (!active) return;
    active = false;
    onStop?.();
  }

  const tick = () => { if (shoot() === false) stop(); };

  /** Le déclencheur vient d'être enfoncé (la première photo est déjà partie) : la rafale démarrera si l'appui dure. */
  function arm() {
    stop();
    delayTimer = setTimeout(() => {
      delayTimer = null;
      active = true;
      onStart?.();
      if (shoot() === false) { stop(); return; }
      intervalTimer = setInterval(tick, intervalMs);
    }, delayMs);
  }

  return { arm, stop, isActive: () => active };
}
